import { globalTranslate } from '@pfsc/shared/locale/app.i18n';

export const COURSE_STATUS = {
  NOT_STARTED: 'not_started',
  COMPLETED: 'completed',
  IN_PROGRESS: 'in_progress',
};

const TO_READABLE = {
  [COURSE_STATUS.NOT_STARTED]: globalTranslate('courseStatus.notStarted'),
  [COURSE_STATUS.IN_PROGRESS]: globalTranslate('courseStatus.inProgress'),
  [COURSE_STATUS.COMPLETED]: globalTranslate('courseStatus.completed'),
};

/** Course status. */
export class CourseStatus {
  constructor(data) {
    this.name = data.name;
    this.value = data.value;
  }

  /**
   * Map to readable
   * @param {CourseStatus["value"]} value Value.
   * @returns {string}
   */
  static toReadable(value) {
    const readableStatus = TO_READABLE[value.value];
    return readableStatus ?? value.name;
  }
}
